import React, { PureComponent } from 'react';
import { animateScroll } from 'react-scroll';
import styles from './BackToTop.css';
import { gcpURL } from '../../lib/utils';

const icon = `${gcpURL}/static/ic-back-to-top.svg`;

class BackToTop extends PureComponent {
  static defaultProps = {
    offset: window.innerHeight / 2,
  };

  state = {
    isActive: false,
  };

  componentDidMount() {
    if (window.scrollY >= this.props.offset) {
      this.setState({
        isActive: true,
      });
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { isActive } = this.state;
    const { offset } = this.props;

    if (window.scrollY >= offset && !isActive) {
      this.setState({
        isActive: true,
      });
    } else if (window.scrollY < offset && isActive) {
      this.setState({
        isActive: false,
      });
    }
  }

  handleClick = () => {
    animateScroll.scrollToTop({
      duration: 500,
      smooth: true,
    });
  }

  render() {
    const { isActive } = this.state;

    return (
      <a className={`${styles.backToTop} ${isActive ? styles.isActive : ''}`} onClick={this.handleClick}>
        <img src={icon} width="25" height="27" />
      </a>
    );
  }
}

export default BackToTop;



// WEBPACK FOOTER //
// ./src/components/BackToTop/index.js